import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const QueueManager = ({ 
  queue = [], 
  currentIndex = 0,
  onReorder,
  onRemove,
  onPlay 
}) => {
  return (
    <div className="queue-manager bg-card rounded-lg border border-border p-6">
      <div className="queue-header flex items-center justify-between mb-4">
        <h3 className="text-lg font-heading font-semibold text-foreground">
          Очередь воспроизведения
        </h3>
        <span className="text-sm text-muted-foreground">
          {queue?.length} {queue?.length === 1 ? 'трек' : 'треков'}
        </span>
      </div>
      <div className="queue-list space-y-2 max-h-96 overflow-y-auto">
        {queue?.map((item, index) => (
          <div
            key={item?.id}
            className={`queue-item flex items-center gap-3 p-3 rounded-lg transition-colors duration-200 ${
              index === currentIndex 
                ? 'bg-primary/10 border border-primary/20' :'hover:bg-muted'
            }`}
          >
            <div className="item-artwork w-12 h-12 rounded-lg overflow-hidden flex-shrink-0">
              <Image 
                src={item?.artwork} 
                alt={item?.artworkAlt}
                className="w-full h-full object-cover"
              />
            </div>

            <div className="item-info flex-1 min-w-0">
              <h4 className="text-sm font-heading font-medium text-foreground truncate">
                {item?.title}
              </h4>
              <p className="text-xs text-muted-foreground truncate">
                {item?.artist}
              </p>
            </div>

            <div className="item-actions flex items-center gap-2">
              {index === currentIndex && (
                <div className="playing-indicator flex items-center gap-1">
                  <div className="w-1 h-3 bg-primary rounded-full animate-pulse"></div>
                  <div className="w-1 h-4 bg-primary rounded-full animate-pulse" style={{ animationDelay: '0.2s' }}></div>
                  <div className="w-1 h-3 bg-primary rounded-full animate-pulse" style={{ animationDelay: '0.4s' }}></div>
                </div>
              )}

              <Button
                variant="ghost"
                size="icon"
                onClick={() => onPlay(index)}
                aria-label="Воспроизвести"
              >
                <Icon name="Play" size={16} color="var(--color-foreground)" />
              </Button>

              <Button
                variant="ghost"
                size="icon"
                onClick={() => onRemove(index)}
                aria-label="Удалить из очереди"
              >
                <Icon name="X" size={16} color="var(--color-foreground)" />
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default QueueManager;